import { render } from "./ModalForm.vue?vue&type=template&id=cf884d5a&scoped=true"
const script = {}

import "./ModalForm.vue?vue&type=style&index=0&id=cf884d5a&scoped=true&lang=css"

import exportComponent from "E:\\Vue_Project\\JamoatFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf884d5a"]])

export default __exports__